<template>
  <div class="w-full flex justify-between consecutive-widget__header" :class="{ 'is-mobile': $store.getters.isMobile }">
    <div class="flex items-center left-box">
      <span>{{ $t('siteBuild.consecutiveWidget.subtitle') }}：</span>
      <div class="number px-2 py-1">{{ currentNumber }}</div>
    </div>
    <div class="flex items-center right-box py-1 px-2">
      <i class="el-icon-timer mr-1 relative" />
      <span class="relative">{{ timeoutString }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    model: {
      type: Object,
      default() {
        return {}
      }
    },
    currentNumber: [String, Number],
    timeoutString: [String],
    activityData: {
      type: Object,
      default() {
        return {}
      }
    }
  }
}
</script>

<style lang="less">
.consecutive-widget__header {
  position: relative;
  color: var(--text-color);
  font-size: 18px;
  margin-top: 20px;
  
  .left-box {
    .number {
      background: var(--countdown-background);
      color: var(--countdown-text-color);
      border-radius: var(--card-radius);
    }
  }
  .right-box {
    background: var(--countdown-background);
    color: var(--countdown-text-color);
    border-radius: var(--card-radius);
  }

  &.is-mobile {
    font-size: 14px;
    margin-top: 10px;
    padding: 0 5px;
  }
}
</style>
